import React, { useEffect } from 'react';
import { Button, ButtonGroup, Card, Col, Form, Row } from 'react-bootstrap';
import HkBadge from '../../components/@hk-badge/@hk-badge';
import AudienceReviewChart from './ChartData/AudienceReviewChart';

const AudienceReviewCard = () => {
    useEffect(() => {
        window.dispatchEvent(new Event('resize'))
    }, [])

    return (
        <Card className="card-border mb-0 h-100">
            <Card.Header className="card-header-action">
                <h6>Collections</h6>
                <div className="card-action-wrap">
                    <ButtonGroup className="d-lg-flex d-none" aria-label="Basic outlined example">
                        <Button variant="outline-light" className="active">All</Button>
                        <Button variant="outline-light">Issued</Button>
                        <Button variant="outline-light">Paid</Button>
                        <Button variant="outline-light">Balance</Button>
                    </ButtonGroup>
                    <Form.Select className="d-lg-none d-flex">
                        <option value={1}>All</option>
                        <option value={2}>Issued</option>
                        <option value={3}>Paid</option>
                        <option value={4}>Balance</option>
                    </Form.Select>
                </div>
            </Card.Header>
            <Card.Body>
                <AudienceReviewChart />
                <div className="separator-full mt-5" />
                <div className="flex-grow-1 ms-lg-3">
                    <Row>
                        <Col xxl={3} sm={6} className="mb-3">
                            <span className="d-block fw-medium fs-7">A/R Balance</span>
                            <div className="d-flex align-items-center">
                                <span className="d-block fs-4 fw-medium text-dark mb-0">$323,000</span>
                                <HkBadge bg="success" size="sm" soft className="ms-1" >
                                    <i className="bi bi-arrow-up" /> 7.5%
                                </HkBadge>
                            </div>
                        </Col>
                        <Col xxl={3} sm={6} className="mb-3">
                            <span className="d-block fw-medium fs-7">A/R Overdue</span>
                            <div className="d-flex align-items-center">
                                <span className="d-block fs-4 fw-medium text-dark mb-0">$175,830</span>
                                <HkBadge bg="danger" size="sm" soft className="ms-1" >
                                    <i className="bi bi-arrow-up" /> 27.2%
                                </HkBadge>
                            </div>
                        </Col>
                        <Col xxl={3} sm={6} className="mb-3">
                            <span className="d-block fw-medium fs-7">Promise to Pay</span>
                            <div className="d-flex align-items-center">
                                <span className="d-block fs-4 fw-medium text-dark mb-0">46.2%</span>
                                <HkBadge bg="success" size="sm" soft className="ms-1" >
                                    <i className="bi bi-arrow-up" /> 32.2%
                                </HkBadge>
                            </div>
                        </Col>
                        <Col xxl={3} sm={6}>
                            <span className="d-block fw-medium fs-7">Broken Promise</span>
                            <div className="d-flex align-items-center">
                                <span className="d-block fs-4 fw-medium text-dark mb-0">3.8%</span>
                                <HkBadge bg="success" size="sm" soft className="ms-1" >
                                    <i className="bi bi-arrow-down" /> -0.88%
                                </HkBadge>
                            </div>
                        </Col>
                    </Row>
                </div>
            </Card.Body>
        </Card>
    )
}

export default AudienceReviewCard
